var CodeSnippetBuilder = /** @class */ (function () {
    function CodeSnippetBuilder() {
        this.codeSnippet = {
            content: '',
            lastUpdateDate: Date.now()
        };
    }
    CodeSnippetBuilder.prototype.withCodeSnippet = function (content) {
        this.codeSnippet.content = content;
        return this;
    };
    CodeSnippetBuilder.prototype.withLastUpdateDate = function (date) {
        this.codeSnippet.lastUpdateDate = date;
        return this;
    };
    CodeSnippetBuilder.prototype.build = function () {
        return this.codeSnippet;
    };
    return CodeSnippetBuilder;
}());
export { CodeSnippetBuilder };
//# sourceMappingURL=code-snippet.builder.js.map